module.exports = __webpack_public_path__ + "static/Casino-04ee88d3aa8b7226701440d4e244a00a.jpg";